import type { LegalPageData, PageProps } from "@/types";
import React, { FC } from "react";
import { ContentManager } from "../content-manager";

export const Legal: FC<PageProps<LegalPageData>> = (props) => {
  const formatDate = (date: string) => {
    const dateObj = new Date(date);
    const month = dateObj.toLocaleString("default", { month: "long" });
    const year = dateObj.getFullYear();
    const day = dateObj.getDate();

    return `${month} ${day}, ${year}`;
  };

  const prepareMobileTable = () => {
    const content = document.querySelector(".legalPage--content");

    if (content) {
      const tables = Array.from(content.querySelectorAll("table"));

      tables.forEach((table) => {
        const thElements = Array.from(tables[0].querySelectorAll("th"));
        const trElements = Array.from(table.querySelectorAll("tr"));

        trElements.forEach((tr) => {
          const tdElements = Array.from(tr.querySelectorAll("td"));

          tdElements.forEach((td, index) => {
            td.setAttribute("data-label", thElements[index].textContent || "");
          });
        });
      });
    }
  };

  React.useEffect(() => {
    if (props.data.page.content.find((e) => e.type === "ctable")) {
      prepareMobileTable();
    }

    const handleScroll = () => {
      const h2Elements = Array.from(
        document.querySelectorAll(".legalPage--content h2")
      );

      h2Elements.forEach((h2) => {
        const rect = h2.getBoundingClientRect();

        // Check if the <h2> element is in the viewport
        if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
          const anchorId = h2.id;
          const anchor = document.querySelector(`a[href="#${anchorId}"]`);

          if (anchor) {
            anchor.classList.add("active");
          }
        } else {
          const anchorId = h2.id;
          const anchor = document.querySelector(`a[href="#${anchorId}"]`);

          if (anchor) {
            anchor.classList.remove("active");
          }
        }
      });
    };

    // Attach scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Call handleScroll on initial load
    handleScroll();

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className="legalPage">
      <div className="wrapper">
        <div className="legalPage--sideLinks">
          <div className="legalPage--sideLinks-title">Content</div>
          <ul className="legalPage--sideLinks-list">
            {props.data.sideLinks.map((link, index) => (
              <li key={index}>
                <a href={`${link.url}`}>{link.label}</a>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <div className="legalPage--date">
            Last updated: <span>{formatDate(props.data.dateUpdate)}</span>
          </div>
          <h1 className="legalPage--title">{props.data.page.title}</h1>
          <ContentManager
            content={props.data.page.content}
            className="legalPage--content"
          />
        </div>
      </div>
    </div>
  );
};
